import React from "react";

import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { AEEmail, AEPhone, canView } from "../AELink";
import { AESVG } from "../svg";
import { AEButton } from "../buttons";
import ModalLayout from "../Dialogs/ModalLayout";
import { useState } from "react";
import { getPrice, VIEW_CONTACTS } from "../../../app/modules/common/pricing";
import { viewContacts } from "../../../app/modules/Users/_redux/crud";
import { AESpinner } from "../../spinner/AESpinner";
import { useDispatch } from "react-redux";
import { fetchWalletStatistics } from "../../../app/pages/Dashboard/_redux/actions";

const viewContactsPrice = getPrice(VIEW_CONTACTS);
const PurchasableContact = ({ entity, _address, getEntity }) => {
  const { formatMessage } = useIntl();
  const canViewContacts = canView(entity.phone);
  const [show, setShow] = useState(false);

  return (
    <div className="card card-custom gutter-b">
      <div className="card-body d-flex p-0 card-rounded">
        <div className="flex-grow-1 p-10">
          <h4 className="mt-2 gutter-b">{formatMessage({ id: "CONTACT" })}</h4>
          {[
            {
              id: "PHONE",
              svg: "/Communication/Call.svg",
              value: <AEPhone value={entity.phone} />,
            },
            {
              id: "EMAIL",
              svg: "/Communication/Mail.svg",
              value: <AEEmail value={entity.email} />,
            },
            {
              id: "ADDRESS",
              svg: "/Map/Marker1.svg",
              value: _address.join(" - "),
            },
          ].map((op) => (
            <div key={op.id} className="d-flex mb-5">
              <AESVG
                size={"md"}
                className={"flex-shrink-0 mr-3"}
                path={op.svg}
              />
              <span className="">
                {op.value}
                <span className={"text-muted ml-2"}>
                  {formatMessage({ id: op.id })}
                </span>
              </span>
            </div>
          ))}
          {!canViewContacts && (
            <AEButton
              additionalClassName="m-auto"
              onClick={() => setShow(true)}
            >
              View Contacts
            </AEButton>
          )}
        </div>
      </div>
      <ModalLayout
        show={show}
        title={formatMessage({ id: "CONTACTS.VIEW" })}
        setShow={setShow}
        modalBody={<PurchaseModalBody key={1} />}
        modalFooter={
          <PurchaseModalFooter setShow={setShow} getEntity={getEntity} />
        }
      />
    </div>
  );
};

// PurchasableContact.propType = {
//   // type: PropTypes.oneOf(["email,phone"]).isRequired,
//   // children: PropTypes.node.isRequired,
//   // value: PropTypes.string.isRequired,
// };
export default PurchasableContact;

const PurchaseModalBody = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <div>
        {formatMessage(
          { id: "CONTACTS.PURCHASE.MESSAGE" },
          { price: <strong>{viewContactsPrice}</strong>, currency: "Coins" }
        )}
      </div>
    </>
  );
};

const PurchaseModalFooter = ({ setShow, getEntity }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = () => {
    setIsLoading(true);
    viewContacts()
      .then((response) => {
        getEntity();
        dispatch(fetchWalletStatistics());
      })
      .catch((error) => {
        // console.log({ error, message: error.response?.data });
      })
      .finally(() => {
        setIsLoading(false);
        setShow(false);
      });
  };
  return (
    <>
      {isLoading && <AESpinner />}
      <AEButton
        variant={"primary"}
        size={"sm"}
        additionalClassName="mr-3"
        onClick={handleSubmit}
        disabled={isLoading}
      >
        {formatMessage({ id: "CONFIRM" })}
      </AEButton>
      <AEButton
        variant={"secondary"}
        size={"sm"}
        onClick={() => setShow(false)}
      >
        {formatMessage({ id: "CANCEL" })}
      </AEButton>
    </>
  );
};
